import React from "react";

export default function VotingUserResult({ result }) {
  return <div>{result ? "찬성" : result === null ? "미투표" : "반대"}</div>;
}
